export const AboutPage = () => {
    return <div>about</div>;
};
